import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=787b396d&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=787b396d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b396d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787b396d')) {
      api.createRecord('787b396d', component.options)
    } else {
      api.reload('787b396d', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=787b396d&scoped=true&", function () {
      api.rerender('787b396d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ogyq2c6sYiCu/JS/comp/SearchFilterTokens.vue"
export default component.exports